var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.391,
    height: 50.042,
    viewBox: "0 0 38.391 50.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M18.2,50.043V8.829c-.241.609-.512,1.229-.814,1.85a20.2,20.2,0,0,1-6.032,7.49A19.477,19.477,0,0,1,.059,21.846l-.059-2a17.516,17.516,0,0,0,10.156-3.282A18.206,18.206,0,0,0,15.584,9.8,27.881,27.881,0,0,0,18.2,0l.988.041H19.2L20.2,0h0a28.005,28.005,0,0,0,2.64,9.858,18.187,18.187,0,0,0,5.429,6.727,17.531,17.531,0,0,0,10.128,3.262l-.059,2a19.472,19.472,0,0,1-11.29-3.677,20.18,20.18,0,0,1-6.032-7.49c-.3-.621-.573-1.24-.814-1.85V50.043Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalArrow);
export default __webpack_public_path__ + "static/media/vertical_arrow.976012670c7ccd1867a16a259b2a0d0f.svg";
export { ForwardRef as ReactComponent };